import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Service from '../views/Service.vue'
import supportConference from '../views/supportConference.vue'
import academicSite from '../views/academicSite.vue'
import supportOSS from '../views/supportOSS.vue'
import Commissioned from '../views/Commissioned.vue'
import Investigation from '../views/Investigation.vue'
import Products from '../views/Products.vue'
import Search from '../views/Search.vue'
import Company from '../views/Company.vue'
import Contact from '../views/Contact.vue'
import Elearning from '../views/Elearning.vue'
import reserveDental from '../views/reserveDental.vue'
import reserveMedical from '../views/reserveMedical.vue'
import Participation from '../views/Participation.vue'
import Registration from '../views/Registration.vue'
import Privacy from '../views/Privacy.vue'
import Sitemap from '../views/Sitemap.vue'
import News from '../views/Newslist.vue'
import Maintenance from '../views/Maintenance.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  component: Home,
  meta: { title: 'コニーシステム', description: '徳島でソフトウェア開発を行っている会社です。私達は研究で得た知識やお客様からのフィードバックをもとに製品開発を行っています。e-Learningシステム、歯科予約システム、診療予約システム等についての、試用についてはお問い合わせください。また弊社では、学会サポート、学術大会ホームページ制作を行っております。演題登録、事前参加登録システムについてもご相談ください。' }
},
{
  path: '/Service',
  name: 'Service',
  component: Service,
  meta: { title: 'サービス', description: '' }
},
{
  path: '/Company',
  name: 'Company',
  component: Company,
  meta: { title: '会社情報', description: '' }
},
{
  path: '/Contact',
  name: 'Contact',
  component: Contact,
  meta: { title: 'お問い合わせ', description: '' }
},
{
  path: '/Service/supportConference',
  name: 'supportConference',
  component: supportConference,
  meta: { title: '学会サポート', description: '' }
},
{
  path: '/Service/academicSite',
  name: 'academicSite',
  component: academicSite,
  meta: { title: '学術機関向けサイト作成', description: '' }
},
{
  path: '/Service/supportOSS',
  name: 'supportOSS',
  component: supportOSS,
  meta: { title: 'OSS製品のサポート', description: '' }
},
{
  path: '/Service/Commissioned',
  name: 'Commissioned',
  component: Commissioned,
  meta: { title: '受託開発', description: '' }
},
{
  path: '/Service/Investigation',
  name: 'Investigation',
  component: Investigation,
  meta: { title: '研究開発', description: '' }
},
{
  path: '/Products',
  name: 'Products',
  component: Products,
  meta: { title: '製品案内', description: '' }
},
{
  path: '/Products/Search',
  name: 'Search',
  component: Search,
  meta: { title: '全文検索システム', description: '' }
},
{
  path: '/Products/Elearning',
  name: 'Elearning',
  component: Elearning,
  meta: { title: 'E-learningシステム', description: '' }
},
{
  path: '/Products/reserveDental',
  name: 'reserveDental',
  component: reserveDental,
  meta: { title: '歯科予約システム', description: '' }
},
{
  path: '/Products/reserveMedical',
  name: 'reserveMedical',
  component: reserveMedical,
  meta: { title: '診療予約システム', description: '' }
},
{
  path: '/Products/Participation',
  name: 'Participation',
  component: Participation,
  meta: { title: '学術集会向けオンライン演題登録/査読システム', description: '' }
},
{
  path: '/Products/Registration',
  name: 'Registration',
  component: Registration,
  meta: { title: '学術集会向け事前参加登録システム', description: '' }
},
{
  path: '/Privacy',
  name: 'Privacy',
  component: Privacy,
  meta: { title: '個人情報保護方針', description: '' }
},
{
  path: '/Sitemap',
  name: 'Sitemap',
  component: Sitemap,
  meta: { title: 'サイトマップ', description: '' }
},
{
  path: '/Service/Maintenance',
  name: 'Maintenance',
  component: Maintenance,
  meta: { title: '運用保守', description: '' }
},
{
  // path: '/News/:id',
  path: '/News',
  name: 'News',
  // component:
  // {
  //   News,
  //   template: ''
  // },
  component: News,
  meta: { title: 'お知らせ一覧', description: '' }
}
// ,
// {
//   path: '/about',
//   name: 'about',
//   component: () => import('../views/About.vue')
// }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    return { x: 0, y: 0 } // トップに移動
  }
})
router.afterEach((to, from) => {
  document.title = to.meta.title
  const description = to.meta.description
  if (description) {
    document.querySelector('meta[name="description"]').setAttribute('content', description)
  }
})
// router.beforeEach((to, from, next) => {
//   const description = to.meta.description
//   if (description) {
//     document.querySelector('meta[name="description"]').setAttribute('content', description)
//   }
//   next()
// })
export default router
